import { TrackerProgressCard } from "../../../components/Trackers/TrackerProgressCard";
import { TrackerThresholdPercentages } from "core/state/Trackers/TrackerThresholdPercentages";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { ReactComponent as WaterIcon } from "@icons/water.svg";
import { useTrackerContext } from "core/state/TrackerContext/TrackerContext";
import { useTranslation } from "react-i18next";

export const WaterTrackerProgressCard = () => {
  const { t } = useTranslation();
  const { getCurrentTrackerValue, getGoal } = useTrackerContext();

  const current = getCurrentTrackerValue(TrackerType.Water);
  let goal = getGoal(TrackerType.Water);
  const percent = current.percentageOf(goal, 0);

  function getProgressMessage(percentage: number): string {
    switch (true) {
      case percentage >= 100:
        return t(`wellbeing.trackers.progress.complete`);
      case percentage > TrackerThresholdPercentages.High:
        return t("wellbeing.trackers.water.progress.high", { goal, percent });
      case percentage >= TrackerThresholdPercentages.Medium:
        return t("wellbeing.trackers.water.progress.medium", { goal, percent });
      default:
        return t("wellbeing.trackers.water.progress.low", { goal });
    }
  }

  return (
    <TrackerProgressCard
      trackerType={TrackerType.Water}
      percentage={percent}
      progressMessage={getProgressMessage(percent)}
      heading={t("wellbeing.trackers.water.progress.heading")}
      goalHeading={t("wellbeing.trackers.water.goal.heading")}
      goalDescription={t("wellbeing.trackers.water.goal.description")}
      goalIncrement={250}
      goalUnit={t("wellbeing.trackers.water.goal.unit")}
      Icon={WaterIcon}
    />
  );
};
